'use strict';

module.exports = {
  address_prefix: 'EOS'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs-ecc/lib/config.js
// module id = 23
// module chunks = 0